import React from 'react'
import { Progress } from 'reactstrap'
import './group-avaliation.css'



const GroupAvaliation = props => {
    // document.getElementById(id).classList.add('show')

    //Principal text color
    const data = props.data
    // console.log(data)
    return (
        <div className='group-avaliation-container'>
            <div className='group-avaliation-principal-content'>
                {data.map((d, i) => {
                    return (

                        <div className='group-avaliation-content' key={i}>
                            <div className='group-avaliation-text'>
                                <span>{d.name}</span>
                                <span>{`${d.percent}% | ${d.hour} Horas`}</span>
                            </div>
                            <Progress value={d.percent.replace(',', '.')} barStyle={{ backgroundColor: `#${Math.floor(Math.random()*16777215).toString(16)}` }} className='group-avaliation-progress' />
                        </div>
                    )
                })}
            </div>
            <div className='group-avaliation-bottom'>
                <span>Avaliação Por Grupo</span>
                <div className='group-avaliation-bottom-icon truck-moving'></div>
            </div>

        </div>
    )
}

export default GroupAvaliation